import { Panel } from '@/components/redesign/bits'
import { Skeleton } from '@/components/ui/skeleton'
import { ErrorState } from '@/components/ui/states'
import { formatRelative } from '@/lib/format'
import { useCspReports } from './api'

const appLabels = { app: 'App', cp: 'Control panel' } as const

/** What browsers report the Content-Security-Policy blocks (enforced since 2026-10-20). */
export function CspReportsCard() {
  const reports = useCspReports()

  return (
    <Panel
      title="Browser security reports"
      sub="The app and control panel tell browsers which sites they may load scripts from and send data to (a Content-Security-Policy). Browsers block anything else and report it here. Expected sources are fine to add to the policy; anything unfamiliar is worth a look. Cloudflare's analytics beacon (static.cloudflareinsights.com) is expected to be blocked."
    >
      {reports.isPending ? (
        <Skeleton className="h-24 rounded-md" />
      ) : reports.isError ? (
        <ErrorState error={reports.error} onRetry={() => void reports.refetch()} />
      ) : reports.data.data.length === 0 ? (
        <p className="empty-line">Nothing reported in the last {reports.data.meta.keep_days} days.</p>
      ) : (
        <div className="tw" style={{ border: 0 }}>
          <table className="t" style={{ minWidth: 720 }}>
            <caption className="sr-only">Browser security reports</caption>
            <thead>
              <tr>
                <th>Blocked</th>
                <th>Rule</th>
                <th>Page</th>
                <th>Where</th>
                <th className="r">Times</th>
                <th>Last seen</th>
              </tr>
            </thead>
            <tbody>
              {reports.data.data.map((r) => (
                <tr key={`${r.app}|${r.directive}|${r.blocked}|${r.page}`}>
                  <td style={{ wordBreak: 'break-all' }}>
                    <b>{r.blocked}</b>
                  </td>
                  <td className="m">{r.directive}</td>
                  <td className="m" style={{ wordBreak: 'break-all' }}>
                    {r.page}
                  </td>
                  <td className="m">{appLabels[r.app]}</td>
                  <td className="r num">{r.count.toLocaleString()}</td>
                  <td className="m" style={{ whiteSpace: 'nowrap' }}>
                    {formatRelative(r.last_seen_at)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {reports.data.meta.total > reports.data.data.length && (
            <div className="t-foot">
              Showing the {reports.data.data.length} most recent of {reports.data.meta.total}.
            </div>
          )}
        </div>
      )}
    </Panel>
  )
}
